import portfolioImg01 from "../images/portfolio.png";
import portfolioImg02 from "../images/portfolio-02.jpeg";
import portfolioImg03 from "../images/portfolio-03.png";
import portfolioImg04 from "../images/portfolio-04.png";
import portfolioImg05 from "../images/portfolio-05.png";
import portfolioImg06 from "../images/portfolio-06.png";
import portfolioImg07 from "../images/portfolio-07.jpg";
import portfolioImg08 from "../images/1.jpg"
import portfolioImg09 from "../images/2.jpg"
import portfolioImg10 from "../images/8.jpg"
import portfolioImg11 from "../images/9.jpg"
import adminDashboardImg from "../images/admindashboardportfolio-02.png";
import androidImg from "../images/android.jpeg";
import landingPageImg from "../images/landingpageportfolio-01.png";


const portfolios = [
  {
    id: "01",
    imgUrl: portfolioImg01,
    category: "Web Design",
    title: "Weather App",
    description:
      "Aplikasi cuaca real-time yang menampilkan informasi temperatur, kelembapan, dan kecepatan angin berdasarkan lokasi. Dilengkapi fitur pencarian kota dengan tampilan yang clean dan informatif.",
    technologies: ["React", "Tailwind css", "OpenWeather API"],
    siteUrl: "https://weather-app-lucknow.netlify.app/",
   
  },
  {
    id: "02",
    imgUrl: portfolioImg04,
    category: "Ux",
    title: "3D Virtual Mall Teknokrat",
    description:
      "Desain 3D virtual mall Universitas Teknokrat Indonesia menggunakan platform Spatial.io. Menampilkan bangunan mall dengan arsitektur modern, area parkir, dan billboard digital dalam lingkungan metaverse yang interaktif.",
    technologies: ["Spatial.io", "3D Modeling", "Metaverse", "Blender"],
    siteUrl: "https://www.spatial.io/s/Mall-Teknokrat-Indonesia-645e4ba7b39e26680851e75e?share=1944802212461214638",
  },
  {
    id: "03",
    imgUrl: portfolioImg02,
    category: "Ux",
    title: "Virtual Meeting Room Teknokrat",
    description:
      "Ruang rapat virtual 3D untuk Rapat Koordinasi Universitas Teknokrat Indonesia di platform Spatial.io. Mendukung interaksi multi-user dengan avatar, presentasi layar besar, dan suasana ruang rapat yang realistis.",
    technologies: ["Spatial.io", "3D Modeling", "Metaverse", "Blender"],
    siteUrl: "https://www.spatial.io/s/Meeting-Room-Teknokrat-6470c1467ba6029f12201e5b?share=502589199180443788",
  },
  {
    id: "04",
    imgUrl: portfolioImg05,
    category: "Web Design",
    title: "ARV.ID Fashion E-Commerce",
    description:
      "Website e-commerce fashion ARV.ID dengan fitur lengkap termasuk sign in, register, shopping cart, dan katalog produk. Menampilkan koleksi fashion seperti Ura Bag dan Pashmina Silk dengan desain UI yang elegan dan modern.",
    technologies: ["PHP", "MySQL", "HTML", "CSS", "JavaScript"],
    siteUrl: "https://github.com/AfitSantoso/Fullstack-ecommerceweb-PHP",
  },
  {
    id: "05",
    imgUrl: portfolioImg03,
    category: "Machine Learning",
    title: "Trash Detection - YOLOv5",
    description:
      "Sistem deteksi sampah menggunakan model YOLOv5 yang mampu mengidentifikasi berbagai jenis sampah secara real-time seperti botol, gelas, dan kantong plastik, dilengkapi dengan confidence score untuk setiap objek yang terdeteksi.",
    technologies: ["Python", "YOLOv5", "OpenCV", "Deep Learning"],
    siteUrl: "https://github.com/AfitSantoso/Trashdetection-with-yolov5",
  },

  {
    id: "06",
    imgUrl: portfolioImg06,
    category: "Ux",
    title: "Virtual Presentation Room Teknokrat",
    description:
      "Ruang presentasi virtual 3D Universitas Teknokrat Indonesia untuk sidang dan seminar di platform Spatial.io. Dilengkapi layar presentasi besar, kursi audiens, dan banner prestasi mahasiswa dalam suasana kampus terbaik ASEAN.",
    technologies: ["Spatial.io", "3D Modeling", "Metaverse", "Blender"],
    siteUrl: "https://www.spatial.io/s/Presentation-Room-Teknokrat-646ad4f8a21fe86ca02df02f?share=4480046784380611478",
  },
  {
    id: "07",
    imgUrl: portfolioImg08,
    category: "Web Design",
    title: "Protest Landing Page",
    description:
      "Desain landing page bertema kampanye sosial dengan ilustrasi karakter yang ekspresif dan warna oranye yang mencolok. Menampilkan layout modern dengan navigasi sederhana dan tombol call-to-action 'Get Started'.",
    technologies: ["Figma", "UI/UX Design", "Illustrator"],
    siteUrl: "#",
  },
  {
    id: "08",
    imgUrl: portfolioImg09,
    category: "Web Design",
    title: "Health Prevention Landing Page",
    description:
      "Landing page bertema pencegahan epidemi dengan desain pink soft yang menenangkan. Menampilkan ilustrasi protokol kesehatan seperti cuci tangan dan penggunaan hand sanitizer, dilengkapi navigasi intuitif dan integrasi media sosial.",
    technologies: ["Figma", "UI/UX Design", "Illustrator"],
    siteUrl: "#",
  },
  {
    id: "09",
    imgUrl: portfolioImg10,
    category: "Ux",
    title: "WebMKR - Website Builder Landing Page",
    description:
      "Landing page premium untuk platform WebMKR dengan tema dark mode yang elegan. Menampilkan integrasi website dan user interface dengan elemen 3D isometric, tombol subscribe dan demo, serta gradien warna ungu-oranye yang eye-catching.",
    technologies: ["Figma", "UI/UX Design", "3D Illustration"],
    siteUrl: "#",
  },
  {
    id: "10",
    imgUrl: portfolioImg11,
    category: "Ux",
    title: "Online Therapy Landing Page",
    description:
      "Landing page untuk platform terapi psikologi online dengan desain ungu yang lembut dan profesional. Menampilkan ilustrasi konsultasi virtual antara pasien dan terapis, dengan navigasi yang clean dan tombol call-to-action yang jelas.",
    technologies: ["Figma", "UI/UX Design", "Illustrator"],
    siteUrl: "#",
  },
  {
    id: "11",
    imgUrl: portfolioImg04,
    category: "Web Design",
    title: "3D Virtual Mall - Exterior View",
    description:
      "Tampilan eksterior dari proyek 3D Virtual Mall Teknokrat Indonesia yang menunjukkan arsitektur bangunan modern berlantai tiga, area parkir yang luas, dan signage digital. Dibangun untuk pengalaman metaverse yang imersif.",
    technologies: ["Spatial.io", "3D Modeling", "Metaverse", "Blender"],
    siteUrl: "#",
  },
  {
    id: "12",
    imgUrl: portfolioImg05,
    category: "Web Design",
    title: "ARV.ID Fashion - Homepage",
    description:
      "Halaman utama website e-commerce fashion ARV.ID yang menampilkan produk unggulan seperti tas dan pashmina silk. Didesain dengan layout responsif dan navigasi yang user-friendly untuk pengalaman belanja online yang optimal.",
    technologies: ["PHP", "MySQL", "HTML", "CSS", "JavaScript"],
    siteUrl: "#",
  },
  {
    id: "13",
    imgUrl: portfolioImg06,
    category: "Web Design",
    title: "Virtual Seminar Room Teknokrat",
    description:
      "Ruang seminar virtual 3D untuk kegiatan akademik Universitas Teknokrat Indonesia. Menampilkan setup presentasi lengkap dengan layar ganda, meja seminar, dan kapasitas audiens yang dapat menampung banyak peserta secara virtual.",
    technologies: ["Spatial.io", "3D Modeling", "Metaverse", "Blender"],
    siteUrl: "#",
  },
  {
    id: "14",
    imgUrl: portfolioImg07,
    category: "ux",
    title: "Appointment Booking Landing Page",
    description:
      "Desain landing page untuk platform booking janji temu dengan tampilan soft blue yang modern. Menampilkan ilustrasi kalender interaktif, ikon lokasi, dan jam, dilengkapi navigasi clean serta tombol 'Learn More' yang mengundang interaksi.",
    technologies: ["Figma", "UI/UX Design", "Illustrator"],
    siteUrl: "#",
  },
  {
    id: "15",
    imgUrl: adminDashboardImg,
    category: "Web Design",
    title: "Loan System - Admin Dashboard",
    description:
      "Dashboard admin untuk sistem pinjaman (Loan System) dengan fitur Loan Review. Menampilkan tabel data pinjaman lengkap dengan informasi ID, username, plafond, jumlah pinjaman, tenor, tanggal pengajuan, dan status review. Didesain untuk role Marketing & Admin.",
    technologies: ["Spring Boot", "React", "Tailwind CSS", "MySQL"],
    siteUrl: "#",
  },
  {
    id: "16",
    imgUrl: androidImg,
    category: "Android",
    title: "Genggamin Mobile App",
    description:
      "Aplikasi mobile Android untuk platform pinjaman tunai Genggamin. Dilengkapi fitur ajukan pinjaman, riwayat transaksi, bantuan, dan berbagai produk pinjaman dengan bunga kompetitif. Tampilan UI modern dengan informasi sisa limit dan promo yang menarik.",
    technologies: ["Java", "Kotlin", "Android SDK", "REST API"],
    siteUrl: "#",
  },
  {
    id: "17",
    imgUrl: landingPageImg,
    category: "Web Design",
    title: "Genggamin Landing Page",
    description:
      "Landing page website untuk platform Genggamin - Solusi Cepat Pinjaman Tunai. Menampilkan tagline 'Mudah, cepat, dan aman dalam satu genggaman tangan Anda' dengan desain gradien ungu yang premium, tombol download Google Play, dan social proof 10.000+ pengguna.",
    technologies: ["Angular", "Tailwind CSS", "Spring Boot"],
    siteUrl: "#",
  },
];

export default portfolios;
